import { FilterFn } from '@tanstack/react-table';
import { registerTableFilter } from '../../common/tanstacktable';
import { DataObjectGroupProcessingStateType } from '../../input-data';
import { ValueDateSelectFilterInput } from './ValueDateSelectFilterInput';

declare module '@tanstack/react-table' {
  interface FilterFns {
    valueDateSelect: FilterFn<any>;
  }
}

registerTableFilter<DataObjectGroupProcessingStateType>(
  'valueDateSelect',
  () => true, // Server-side filtering
  ValueDateSelectFilterInput,
);
